import { render, staticRenderFns } from "./zhanghu.vue?vue&type=template&id=578b3daf&"
import script from "./zhanghu.vue?vue&type=script&lang=js&"
export * from "./zhanghu.vue?vue&type=script&lang=js&"
import style0 from "./zhanghu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports